import React from "react";
import HeaderComponent from "./HeaderComponent";
import SearchComponent from "./SearchComponent";
import BackgroundAndTextComponent from "./BackgroundAndTextComponent";
import CardComponent from "./CardComponent";
import PaginationComponent from "./PaginationComponent";
import EnquiryComponent from "./EnquiryComponent";
import FooterComponent from "./FooterComponent";
import FlashOfferSearch from "./FlashOfferSearch";
import ThemeComponent from "./ThemeComponent";

const Main = () => {
  return (
    <div className="fluid-container">
      <HeaderComponent />
      <BackgroundAndTextComponent />
      <SearchComponent />
      <FlashOfferSearch />
      <ThemeComponent />
      <CardComponent />
      <PaginationComponent />
      <EnquiryComponent />
      <FooterComponent />
    </div>
  );
};

export default Main;
